import type { ReactNode } from 'react'
import type { MarketingIconKind } from '../../_data/marketingContent'
import type { MarketingIconProps } from './types'
import { IconShell } from './styled'

const ICON_PIXEL_SIZE: Record<NonNullable<MarketingIconProps['size']>, number> = {
  small: 18,
  medium: 22,
  large: 28,
}

const ICON_PATHS: Record<MarketingIconKind, ReactNode> = {
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1.5 1.5" />
      <path d="M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1.5-1.5" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="9" r="3.5" />
      <path d="M3 20c0-3.31 2.69-6 6-6s6 2.69 6 6" />
      <circle cx="17" cy="8" r="2.5" />
      <path d="M15 14h.5c2.49 0 4.5 2.01 4.5 4.5V20" />
    </>
  ),
  embed: (
    <>
      <path d="M8 8 3 12l5 4" />
      <path d="m16 8 5 4-5 4" />
      <path d="m13 5-2 14" />
    </>
  ),
  bell: (
    <>
      <path d="M6 9a6 6 0 1 1 12 0v3l2 4H4l2-4V9Z" />
      <path d="M10 19a2 2 0 0 0 4 0" />
    </>
  ),
  building: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="1.5" />
      <path d="M9 8h2" />
      <path d="M13 8h2" />
      <path d="M9 12h2" />
      <path d="M13 12h2" />
      <path d="M9 21v-4h6v4" />
    </>
  ),
  briefcase: (
    <>
      <rect x="3" y="7" width="18" height="13" rx="1.5" />
      <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
      <path d="M3 13h18" />
    </>
  ),
  phone: (
    <>
      <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2Z" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3Z" />
      <path d="M19 16l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8.8-2Z" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3l8 3v6c0 4.5-3.3 8.4-8 9-4.7-.6-8-4.5-8-9V6l8-3Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  wallet: (
    <>
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <path d="M3 10h18" />
      <circle cx="16.5" cy="14.5" r="1.2" />
    </>
  ),
}

const MarketingIcon = ({
  kind,
  size = 'medium',
}: MarketingIconProps): JSX.Element => {
  const pixelSize = ICON_PIXEL_SIZE[size]
  return (
    <IconShell size={size} aria-hidden="true">
      <svg
        width={pixelSize}
        height={pixelSize}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {ICON_PATHS[kind]}
      </svg>
    </IconShell>
  )
}

export default MarketingIcon
